/* import __COLOCATED_TEMPLATE__ from './file-question.hbs'; */
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import styles from './file-question.module.scss';

export default class RequestPrescreenerQuestionTypesFileQuestion extends Component {
  @service prescreener;
  @service media;

  styles = styles;

  get isDesktopFeatureEnabled() {
    return !this.media.isXsDown;
  }

  get context() {
    return this.isDesktopFeatureEnabled ? 'forDesktop' : 'forMobile';
  }

  get primaryInstructions() {
    return `booking.prescreener.questions.file.${this.context}.primary`;
  }

  get secondaryInstructions() {
    return `booking.prescreener.questions.file.${this.context}.secondary`;
  }

  @action
  onFileUploadFront(file) {
    this.prescreener.upload.insuranceCardFront = file;
    this.sendOnChange(file.name);
  }

  @action
  onFileUploadBack(file) {
    this.prescreener.upload.insuranceCardBack = file;
    this.sendOnChange(file.name);
  }

  sendOnChange(fileName) {
    this.args.onChange?.(this.args.question, !!fileName);
  }
}
